import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SelectItem, MenuItem, MessageService } from 'primeng/api';
import { SignaturePad } from 'angular2-signaturepad';
//import { CkCapitalWebsiteService } from '../services/ck-website-service';
import { CookieService } from 'ngx-cookie-service';
import { loadStripe, Stripe, StripeCardElement } from '@stripe/stripe-js';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { RehabBudgetComponent } from '../rehab-budget/rehab-budget.component';

@Component({
  selector: 'app-loan-application',
  templateUrl: './loan-application.component.html',
  styleUrls: ['./loan-application.component.scss'],
  providers: [MessageService]
})
export class LoanApplicationComponent implements OnInit {

  @ViewChild('sigpad1') loanInfoGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad2') ackAgreementGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad3') borrowerAuthorizationGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad4') ecoaGuarantorSignaturePad: SignaturePad;
  @ViewChild('sigpad5') nonOwnerOccupancyGuarantorSignaturePad: SignaturePad;
  @ViewChild(RehabBudgetComponent) rehabBudget: RehabBudgetComponent;
  
  stripe: Stripe;
  stripePromise;
  stripeCardElement: StripeCardElement;

  elementsFormStyle = {
    base: {
      color: '#303238',
      fontSize: '16px',
      fontFamily: '"Open Sans", sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#CFD7DF',
      },
    },
    invalid: {
      color: '#e5424d',
      ':focus': {
        color: '#303238',
      },
    },
  };

  applicationSubmittedSuccessfully: boolean;
  displayStartApplicationModal: boolean;
  cookieExpiredDate: Date;
  submissionAcknowledgement: boolean = false;
  isSubmitting: boolean;
  isReferralValid: boolean;
  pre_approval_only: boolean = false;
  under_contract: boolean = false;
  no_subject_property: boolean = false;
  applicationForm: FormGroup;
  stepItems: MenuItem[];
  exitStrategy: SelectItem[];
  propertyType: SelectItem[];
  mortgageType: SelectItem[];
  programType: SelectItem[];
  loanTerm: SelectItem[];  
  states: SelectItem[];
  yesno: SelectItem[];
  ownOrRent: SelectItem[];
  entityType: SelectItem[];
  selectedDeclaration1: string;
  referralWebAddress: string;
  referralDisplayName: string;
  signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 1500,
    'canvasHeight': 150
  };
  
  loan_officer: string;
  how_you_heard_about_us: string;
  entity_name: string;
  entity_type: string;
  entity_ein_number: string;
  personal_first_name: string;
  personal_last_name: string;
  personal_date_of_birth: Date
  personal_primary_residence: string;
  personal_city: string;
  personal_state: string;
  personal_zip: number;
  personal_own_or_rent: string;
  personal_phone_number: number;
  personal_email: string;
  personal_ssn: number;
  personal_number_of_years: number;
  experience_properties_rehabbed: number;
  experience_rental_properties_currently_owned: number;
  experience_proof_ownership: number;
  property_address: string;
  property_city: string;
  property_state: string;
  property_zip: number;
  property_exit_strategy: string;
  property_type: string;
  loan_program_type: string;
  loan_purchase_price: number;
  loan_rehab_cost: number;
  loan_mortgage_type: string;
  loan_term: number;
  loan_after_repaired_value: number;
  loan_info_guarantor_signature: string;
  loan_info_signature_date: Date;
  refinance_orig_purchase_price: number
  refinance_date_acquired: Date;
  refinance_mortgage_lender: string;
  refinance_mortgage_email: string;
  refinance_current_payoff: number
  refinance_payment_amount: number;
  refinance_contact_name: string;
  refinance_phone: number;
  leased_monthly_rent: number;
  leased_yearly_taxes: number;
  leased_yearly_hoa_dues: number;
  leased_lease_expiration_date: Date;
  leased_month_to_month: boolean;
  leased_yearly_insurance: number;
  leased_hoa_contact: string;
  contact_interior_contact_name: string;
  contact_interior_relationship: string;
  contact_interior_email: string;
  contact_interior_phone: number;
  contact_title_company_name: string;
  contact_title_company_contact_name: string;
  contact_title_email: string;
  contact_title_phone: number;
  hoa_contact_name: string;
  hoa_contact_email: string;
  hoa_relationship: string;
  hoa_phone: number;
  declarations_outstanding_judgements: boolean;
  declarations_declared_bankruptcy: boolean;
  declarations_foreclosed: boolean;
  declarations_lawsuit: boolean;
  declarations_guilty_criminal_offense: boolean;
  declarations_delinquent_or_default: boolean;
  declarations_usa_citizen: boolean;
  declarations_permanent_resident: boolean;
  declarations_obligated_foreclosure: boolean;
  declarations_detailed_explanations: string;
  government_monitoring_do_not_furnish_info: boolean;
  government_monitoring_ethnicity: string;
  government_monitoring_race: string;
  government_monitoring_sex: string;
  ack_agreement_guarantor_printed_name: string;
  ack_agreement_guarantor_signature: string;
  ack_agreement_signature_date: Date;
  borrower_authorization_guarantor_printed_name: string;
  borrower_authorization_guarantor_signature: string;
  borrower_authorization_signature_date: Date;
  ecoa_guarantor_printed_name: string;
  ecoa_guarantor_signature: string;
  ecoa_signature_date: Date;
  non_owner_occupancy_guarantor_printed_name: string;
  non_owner_occupancy_guarantor_signature: string;
  non_owner_occupancy_entity_name: string;
  non_owner_occupancy_signature_date: Date;
  partner_1_first_name: string;
  partner_1_last_name: string;
  partner_1_date_of_birth: Date;
  partner_1_primary_residence: string;
  partner_1_phone: number;
  partner_1_ownership_percentage: number;
  partner_1_ssn: number;
  partner_1_email: string;
  partner_2_first_name: string;
  partner_2_last_name: string;
  partner_2_date_of_birth: Date;
  partner_2_primary_residence: string;
  partner_2_phone: number;
  partner_2_ownership_percentage: number;
  partner_2_ssn: number;
  partner_2_email: string;
  do_not_furnish_info: boolean;

  constructor(private route: ActivatedRoute, 
    private formBuilder: FormBuilder, 
    private cookieService: CookieService,
    private messageService: MessageService) { 
    this.applicationForm = this.formBuilder.group({
      ReferralName: [''],
      LoanOfficer: [''],
      HowDidYouHear: [''],
      EntityName: [''],
      EntityType: [''],
      EINNumber: [''],
      PersonalFirstName: [''],
      PersonalLastName: [''],
      PersonalBirthDate: [''],
      PersonalSSN: [''],
      PersonalPrimaryResidence: [''],
      PersonalCity: [''],
      PersonalState: [''],
      PersonalZip: [''],
      PersonalOwnOrRent: [''],
      PersonalOwnOrRentNumberOfYears: [''],
      PersonalPhone: [''],
      PersonalEmail: [''],
      ExperienceRehab: [''],
      ExperienceRental: [''],
      ExperienceProofOwnership: [''],
      SeekingPreApprovalOnly: [false],
      NoSubjectProperty: [false],
      UnderContract: [false],
      SubjectPropertyAddress: [''],
      SubjectCity: [''],
      SubjectState: [''],
      SubjectZip: [''],
      PropertyExitStrategy: [''],
      SubjectPropertyType: [''],
      LoanProgramType: [''],
      MortgageType: [''],
      PurchasePrice: [''],
      LoanTermMonths: [''],
      RehabCost: [''],
      AfterRepairValue: [''],
      RefinanceOriginalPurchasePrice: [''],
      RefinanceCurrentPayoff: [''],
      RefinanceDateAcquired: [''],
      RefinancePaymentAmount: [''],
      RefinanceMortgageLender: [''],
      RefinanceContactName: [''],
      RefinanceMortgageEmail: [''],
      RefinancePhone: [''],
      LoanInfoSignature: [''],
      LoanInfoSignatureDate: [''],
      LeasedMonthlyRent: [''],
      LeasedExpiration: [''],
      LeaseMonthToMonth: [false],
      LeasedYearlyTaxes: [''],
      LeasedYearlyInsurance: [''],
      LeasedYearlyHOADues: [''],
      LeasedHOAContact: [''],
      InteriorContact: [''],
      InteriorContactRelationship: [''],
      InteriorContactEmail: [''],
      InteriorContactPhone: [''],
      ContactTitleCompanyName: [''],
      ContactTitleContactName: [''],
      ContactTitleEmail: [''],
      ContactTitlePhone: [''],
      HOAContactName: [''],
      HOARelationship: [''],
      HOAContactEmail: [''],
      HOAPhone: [''],
      DeclarationsJudgements: [''],
      DeclarationsBankrupt: [''],
      DeclarationsForeclosed: [''],
      DeclarationsLawsuit: [''],
      DeclarationsCriminalOffense: [''],
      DeclarationsDelinquent: [''],
      DeclarationsUSCitizen: [''],
      DeclarationsPermanentResident: [''],
      DeclarationsObligatedForeclosure: [''],
      DeclarationsExplanations: [''],
      DoNotFurnishPersonalInfo: [false],
      SexMale: [false],
      SexFemale: [false],
      HispanicLatino: [false],
      NotHispanicLatino: [false],
      Indian: [false],
      AfricanAmerican: [false],
      White: [false],
      Asian: [false],
      Hawaiian: [false],
      AckAgreementPrintedName: [''],
      AckAgreementDate: [''],
      AckAgreementSignature: [''],
      BorrowerAuthPrintedName: [''],
      BorrowerAuthSignatureDate: [''],
      BorrowerAuthSignature: [''],
      ECOAPrintedName: [''],
      ECOASignatureDate: [''],
      ECOASignature: [''],
      NonOwnerOccupancyPrintedName: [''],
      NonOwnerOccupancySignatureDate: [''],
      NonOwnerOccupancySignature: [''],
      NonOwnerOccupancyEntity: [''],
      Partner1FirstName: [''],
      Partner1LastName: [''],
      Partner1Birthdate: [''],
      Partner1SSN: [''],
      Partner1PrimaryResidence: [''],
      Partner1Phone: [''],
      Partner1Email: [''],
      Partner1Ownership: [''],
      Partner2FirstName: [''],
      Partner2LastName: [''],
      Partner2Birthdate: [''],
      Partner2SSN: [''],
      Partner2PrimaryResidence: [''],
      Partner2Phone: [''],
      Partner2Email: [''],
      Partner2Ownership: [''],
      SubmissionAcknowledgement: [false],

      RehabBudget: ['']
    })
  }

  ngOnInit(): void {
    this.loadStripeElements();

    this.docReady(function() {
      // DOM is loaded and ready for manipulation here
      var paymentSteps = document.querySelectorAll('#PaymentSteps li')
      paymentSteps[1].classList.add('ui-state-highlight');
      paymentSteps[1].classList.remove('ui-state-disabled');
    });
    

    this.displayStartApplicationModal = true;
    this.populateDropDownSelections();

    this.route.queryParams.subscribe(params => {
      this.referralWebAddress = params['referral'];

      if (this.referralWebAddress != undefined) {
        this.setAffiliateReferral();
      }
      else {
        this.referralWebAddress = this.cookieService.get('Referral');
        if (this.referralWebAddress.length > 0) {
          this.setAffiliateReferral();
        }
      }

      this.loan_info_signature_date = new Date();
      this.ack_agreement_signature_date = new Date();
      this.borrower_authorization_signature_date = new Date();
      this.ecoa_signature_date = new Date();
      this.non_owner_occupancy_signature_date = new Date();
    });
  }

  async loadStripeElements() {
    const params = {
      body: { }, 
    };

    //The credit card money is going into their stripe account so we pass the stripeAccount header
    try {
      this.stripePromise = loadStripe(environment.kzPublishableKey, {
        stripeAccount: environment.ckStripeAccount
      })
      this.startCheckout();
    }
    catch(ex) {
      console.log(ex);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: ex });
      window.scrollTo(0, 0);
    }
  }

  async startCheckout() {
    // Call your backend to create the Checkout session.
    // When the customer clicks on the button, redirect them to Checkout.
    this.stripe = await this.stripePromise;
    var elements = this.stripe.elements();
    this.stripeCardElement = elements.create("card", { style: this.elementsFormStyle });
    this.stripeCardElement.mount("#card-element");

    this.stripeCardElement.on('change', ({error}) => {
      let displayError = document.getElementById('card-errors');
      if (error) {
        //this.bookingTickets = false;
        displayError.textContent = error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  createPaymentMethod() {
    var a = this;
    this.isSubmitting = true;
    this.messageService.clear();

    this.createPaymentMethodAtStripe().then(function(result) {
      // Handle result.error or result.paymentMethod
      if (result.includes("ERROR:")) {
        a.isSubmitting = false;
        return result;
      }
      else {
        a.finishAndBookCheckout(result);
      }

      return null;
    });
  }

  async createPaymentMethodAtStripe():Promise<string> {
    let displayError = document.getElementById('card-errors');
    return this.stripe.createPaymentMethod({
      type: 'card',
      card: this.stripeCardElement
    }).then(function(result) {
      // Handle result.error or result.paymentMethod
      if (result.error) {
        console.log(result.error);
        displayError.textContent = result.error.message;
        return Promise.resolve('ERROR: ' + result.error.message);
      }
      else {
        //console.log(result.paymentMethod.id);
        return Promise.resolve(result.paymentMethod.id);
      }
    });
  }

  async finishAndBookCheckout(paymentMethodOrIntent) {
    try {
       this.isSubmitting = true;
       
       //Re-grab the affiliate referral name
      this.referralWebAddress = this.cookieService.get('Referral');
      this.applicationForm.patchValue({ReferralName: this.referralWebAddress});

      //Add the signatures to the form
      this.applicationForm.patchValue({LoanInfoSignature: this.loan_info_guarantor_signature});
      this.applicationForm.patchValue({ECOASignature: this.ecoa_guarantor_signature});
      this.applicationForm.patchValue({NonOwnerOccupancySignature: this.non_owner_occupancy_guarantor_signature});
      this.applicationForm.patchValue({BorrowerAuthSignature: this.borrower_authorization_guarantor_signature});
      this.applicationForm.patchValue({AckAgreementSignature: this.ack_agreement_guarantor_signature});

      //Add the rehab buget if it's there
      if (this.rehabBudget) {
        this.applicationForm.patchValue({RehabBudget: this.rehabBudget.rehabItems});
      }
      else {
        this.applicationForm.patchValue({RehabBudget: []});
      }

      //Hide the submit button and display the spinner while the form is submitting
      document.getElementById('SubmitContainer').style.display = 'none';
      document.getElementById('ValidationErrors').innerHTML = "";
      this.isSubmitting = true;
      setTimeout(function(){ 
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);

      const params = {
        body: {
          application: this.applicationForm.value,
          paymentMethodId: paymentMethodOrIntent
        }
      }

      var applicationResponse = await API.post('ckpublicapi', '/api/loan-application', params)

      if (applicationResponse.success) {
        this.applicationSubmittedSuccessfully = true;
        this.isSubmitting = false;

        //clear all the data in the form
        this.applicationForm.reset();

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Thanks for your application! You should receive an email confirmation, and we will be reaching out soon.'});
        this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: 'Thanks for your application! You should receive an email confirmation, and we will be reaching out soon.'});
      }
      else if (applicationResponse.validationErrors) {
        //Show the button again and hide the spinner
        document.getElementById('SubmitContainer').style.display = '';
        this.isSubmitting = false;

        applicationResponse.validationErrors.forEach(function (value) {
          var errorContainer = document.getElementById('ValidationErrors');
          errorContainer.innerHTML = errorContainer.innerHTML + "<strong><li style='color:red'>" + value + "</li></strong>";
        });

        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'There were validation errors, please check and submit again' });
        this.messageService.add({ key: 'tst', severity: 'warn', summary: 'Warning', detail: 'There were validation errors, please check and submit again' });
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'There was an unknown error submitting your application. Please contact us!' });
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: 'There was an unknown error submitting your application. Please contact us!' });
      }
    
      this.isSubmitting = false;
    }
    catch (ex) {
      console.log(ex);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: ex.message });
      this.isSubmitting = false;
    }
  }

  toggleMenu() {
    let ul = document.getElementById('menu');
    ul.classList.toggle('mobile-nav');

    let div = document.getElementById('mobile-menu');
    div.classList.toggle('is-active');
  }

  async insertNewLead() {
    document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.add('pi-spinner'); 
    document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.add('pi-spin'); 
    document.getElementById('LeadValidationsContainer').innerHTML = "";

    if (!this.personal_first_name || !this.personal_last_name || !this.personal_email || !this.personal_phone_number) {
      var errorContainer = document.getElementById('LeadValidationsContainer');
      errorContainer.innerHTML = "<strong><li style='color:red'>Ensure you have entered all input fields</li></strong>";
      document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spinner'); 
      document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spin');
    }
    else {
      const params = {
        body: { 
          lead: {
            firstName: this.personal_first_name,
            lastName: this.personal_last_name,
            email: this.personal_email,
            phone: this.personal_phone_number
          }
        }
      };
      var leadResponse = await API.post('ckpublicapi', '/api/loan-lead', params);
      if (leadResponse.success) {
        //Close the modal
        this.displayStartApplicationModal = false;
        document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spinner'); 
        document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spin');
      }
      else {
        var errorContainer = document.getElementById('LeadValidationsContainer');
        errorContainer.innerHTML = "<strong><li style='color:red'>Ensure you have entered a name and valid email</li></strong>";
        document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spinner'); 
        document.getElementById('LeadButton').getElementsByTagName('span')[0].classList.remove('pi-spin'); 
        console.log(leadResponse);
      }
    }
  }

  applicationSubmit(appForm) {
    //Re-grab the affiliate referral name
    this.referralWebAddress = this.cookieService.get('Referral');
    appForm.patchValue({ReferralName: this.referralWebAddress});

    //Add the signatures to the form
    appForm.patchValue({LoanInfoSignature: this.loan_info_guarantor_signature});
    appForm.patchValue({ECOASignature: this.ecoa_guarantor_signature});
    appForm.patchValue({NonOwnerOccupancySignature: this.non_owner_occupancy_guarantor_signature});
    appForm.patchValue({BorrowerAuthSignature: this.borrower_authorization_guarantor_signature});
    appForm.patchValue({AckAgreementSignature: this.ack_agreement_guarantor_signature});

    //Hide the submit button and display the spinner while the form is submitting
    document.getElementById('SubmitContainer').style.display = 'none';
    document.getElementById('ValidationErrors').innerHTML = "";
    this.isSubmitting = true;
    setTimeout(function(){ 
      window.scrollTo(0, document.body.scrollHeight);
    }, 100);

    // var apiRequest = this.websiteService.postNewLoanApplicationSubmission(JSON.stringify(appForm.value));
    //   apiRequest.subscribe(
    //     results => {
    //       console.log(JSON.stringify(results));
    //       var submissionResult = results;
    //       if (submissionResult.wasSuccessful) {
    //         this.applicationSubmittedSuccessfully = true;
    //         this.isSubmitting = false;

    //         //clear all the data in the form
    //         this.applicationForm.reset();
    //       }
    //       else {
    //         //Show the button again and hide the spinner
    //         document.getElementById('SubmitContainer').style.display = '';
    //         this.isSubmitting = false;

    //         submissionResult.errors.forEach(function (value) {
    //           var errorContainer = document.getElementById('ValidationErrors');
    //           errorContainer.innerHTML = errorContainer.innerHTML + "<strong><li style='color:red'>" + value + "</li></strong>";
    //         });
    //       }
    //     },
    //     err => {
    //       console.log(err);
    //       document.getElementById('SubmitContainer').style.display = '';
    //       this.isSubmitting = false;
    //       var errorContainer = document.getElementById('ValidationErrors');
    //       errorContainer.innerHTML = errorContainer.innerHTML + "<strong><li style='color:red'>There has been an error submitting the application</li></strong>";
    //       //this.messageService.add({ severity: "error", detail: "Error! " + err });
    //     });
  }

  setAffiliateReferral() {
    // var apiRequest = this.websiteService.getValidAffiliateReferral(this.referralWebAddress);
    //   apiRequest.subscribe(
    //     results => {
    //       var referralResponse = results;
    //       if (referralResponse.isValidReferral) {
    //         this.isReferralValid = true;
    //         this.cookieExpiredDate = new Date();
    //         this.cookieExpiredDate.setDate( this.cookieExpiredDate.getDate() + 7 );
    //         this.cookieService.set('Referral', this.referralWebAddress, this.cookieExpiredDate);
    //         this.referralDisplayName = referralResponse.displayName;

    //         if (referralResponse.isLoanOfficer) {
    //           this.loan_officer = referralResponse.displayName;
    //         }
    //       }
    //       else {
    //         this.isReferralValid = false;
    //       }
    //     },
    //     err => {
    //       this.isReferralValid = false;
    //       console.log(err);
    //       //this.messageService.add({ severity: "error", detail: "Error! " + err });
    //     });
  }

  //----------------------------------
  clearSignatureLoanPart() {
    this.loan_info_guarantor_signature = null;
    this.loanInfoGuarantorSignaturePad.clear();
  }

  signatureLoanPartDrawComplete() {
    this.loan_info_guarantor_signature = this.loanInfoGuarantorSignaturePad.toDataURL();
  }
  //----------------------------------

  //----------------------------------
  clearAgreementSignature() {
    this.ack_agreement_guarantor_signature = null;
    this.ackAgreementGuarantorSignaturePad.clear();
  }

  ackAgreementDrawComplete() {
    this.ack_agreement_guarantor_signature = this.ackAgreementGuarantorSignaturePad.toDataURL();
  }
  //----------------------------------

  //----------------------------------
  clearBorrowerAuthSignature() {
    this.borrower_authorization_guarantor_signature = null;
    this.borrowerAuthorizationGuarantorSignaturePad.clear();
  }

  borrowerAuthDrawComplete() {
    this.borrower_authorization_guarantor_signature = this.borrowerAuthorizationGuarantorSignaturePad.toDataURL();
  }
  //----------------------------------

  //----------------------------------
  clearEcoaSignature() {
    this.ecoa_guarantor_signature = null;
    this.ecoaGuarantorSignaturePad.clear();
  }

  ecoaDrawComplete() {
    this.ecoa_guarantor_signature = this.ecoaGuarantorSignaturePad.toDataURL();
  }
  //----------------------------------

  //----------------------------------
  clearNonOwnerOccupancySignature() {
    this.non_owner_occupancy_guarantor_signature = null;
    this.nonOwnerOccupancyGuarantorSignaturePad.clear();
  }

  nonOwnerOccupancyDrawComplete() {
    this.non_owner_occupancy_guarantor_signature = this.nonOwnerOccupancyGuarantorSignaturePad.toDataURL();
  }
  //----------------------------------

  populateDropDownSelections() {
    this.yesno = [
      { label:'Select', value: null },
      { label:'Yes', value: 1 },
      { label:'No', value: 0 }
    ];

  this.ownOrRent = [
    { label:'Select', value: null },
    { label:'Own', value: "Own" },
    { label:'Rent', value: "Rent" }
  ];

  this.entityType = [
    { label:'Select', value: null },
    { label:'LLC', value: "LLC" },
    { label:'Corporation', value: "C-Corporation" }
  ];

  this.propertyType = [
    { label:'Select', value: null },
    { label:'2-4 Unit', value: "2-4 Unit" },
    { label:'5-50 Unit', value: "5-50 Unit" },
    { label:'Condominium', value: "Condominium" },
    { label:'Single Family', value: "Single Family" }
  ];

  this.mortgageType = [
    { label:'Select', value: null },
    { label:'Purchase', value: "Purchase" },
    { label:'Purchase + Rehab', value: "Purchase + Rehab" },
    { label:'Purchase - Rental Finance', value: "Purchase - Rental Finance" },
    { label:'Refinance - Rental Finance', value: "Refinance - Rental Finance" },
    { label:'Refinance + Rehab', value: "Refinance + Rehab" },
    { label:'Refinance - Bridge', value: "Refinance - Bridge" }
  ];

  this.programType = [
    { label:'Select', value: null },
    { label:'Purchase', value: "Purchase" },
    { label:'Refinance', value: "Refinance" }
  ];

  this.exitStrategy = [
    { label:'Select', value: null },
    { label:'Improve & Sell', value: "Improve & Sell" },
    { label:'Long-term Hold', value: "Long-term Hold" }
  ];

  this.loanTerm = [
    { label:'Select', value: null },
    { label:'6 Month', value: 6 },
    { label:'12 Month', value: 12 },
    { label:'24 Month', value: 24 },
    { label:'5 Year', value: 60 },
    { label:'10 Year', value: 120 },
    { label:'15 Year', value: 180 },
    { label:'30 Year', value: 360 },
  ];

  this.states = [
    { label:'Select', value: null },
    { label:'Alabama', value: "AL" },
    { label:'Alaska', value: "AK" },
    { label:'Arizona', value: "AZ" },
    { label:'Arkansas', value: "AR" },
    { label:'California', value: "CA" },
    { label:'Colorado', value: "CO" },
    { label:'Connecticut', value: "CT" },
    { label:'Delaware', value: "DE" },
    { label:'Florida', value: "FL" },
    { label:'Georgia', value: "GA" },
    { label:'Hawaii', value: "HI" },
    { label:'Idaho', value: "ID" },
    { label:'Illinois', value: "IL" },
    { label:'Indiana', value: "IN" },
    { label:'Iowa', value: "IA" },
    { label:'Kansas', value: "KS" },
    { label:'Kentucky', value: "KY" },
    { label:'Louisiana', value: "LA" },
    { label:'Maine', value: "ME" },
    { label:'Maryland', value: "MD" },
    { label:'Massachusetts', value: "MA" },
    { label:'Michigan', value: "MI" },
    { label:'Minnesota', value: "MN" },
    { label:'Mississippi', value: "MS" },
    { label:'Missouri', value: "MO" },
    { label:'Montana', value: "MT" },
    { label:'Nebraska', value: "NE" },
    { label:'Nevada', value: "NV" },
    { label:'New Hampshire', value: "NH" },
    { label:'New Jersey', value: "NJ" },
    { label:'New Mexico', value: "NM" },
    { label:'New York', value: "NY" },
    { label:'North Carolina', value: "NC" },
    { label:'North Dakota', value: "ND" },
    { label:'Ohio', value: "OH" },
    { label:'Oklahoma', value: "OK" },
    { label:'Oregon', value: "OR" },
    { label:'Pennsylvania', value: "PA" },
    { label:'Rhode Island', value: "RI" },
    { label:'South Carolina', value: "SC" },
    { label:'South Dakota', value: "SD" },
    { label:'Tennessee', value: "TN" },
    { label:'Texas', value: "TX" },
    { label:'Utah', value: "UT" },
    { label:'Vermont', value: "VT" },
    { label:'Virginia', value: "VA" },
    { label:'Washington', value: "WA" },
    { label:'West Virginia', value: "WV" },
    { label:'Wisconsin', value: "WI" },
    { label:'Wyoming', value: "WY" },
  ];

  this.stepItems = [
    {label: 'Credit Analysis $49'},
    {label: 'Process/Underwriting $500'},
    {label: 'Appraisal/Inspections $450'},
    {label: 'Let\'s Close!'},
];
  }

  redirectToCkHomePage() {
    document.getElementById('ApplicationCompleteButton').getElementsByTagName('span')[0].classList.add('pi-spinner'); 
    document.getElementById('ApplicationCompleteButton').getElementsByTagName('span')[0].classList.add('pi-spin'); 
    window.location.href = "https://ckcapitalfinance.com";
  }

  docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
} 

underContractChange(event) {
  if (event.checked) {
    
  }
}
}
